/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDatasetType, getSchemeFromTilesetDataset } from 'features/builder/state/builderSliceUtils'
import { KeplerTable, LayerTypes, TilingScheme } from 'features/builder/types'
import { MapType } from 'features/maps/types'
import { DEFAULT_AGGREGATION_LEVEL_CLUSTER } from 'features/builder/ui/builderConstants'
import SpatialIndexLayer, { spatialIndexVisConfigs } from './SpatialIndexLayer'

export const TEXT_LABEL_INDEX = 0
const RADIUS_RANGE_MINIMUM = 8
const RADIUS_RANGE_MAXIMUM = 80

const DEFAULT_VIS_CONFIG = {
  ...spatialIndexVisConfigs,
  radiusRange: {
    type: 'number',
    isRanged: true,
    range: [RADIUS_RANGE_MINIMUM, RADIUS_RANGE_MAXIMUM],
    defaultValue: [12, 64]
  },
  strokeOpacity: {
    type: 'number',
    defaultValue: 1
  },
  thickness: {
    type: 'number',
    defaultValue: 2,
    label: 'layerVisConfigs.strokeWidth',
    isRanged: false,
    range: [0, 100],
    step: 0.1,
    group: 'stroke',
    property: 'thickness'
  },
  opacity: {
    type: 'number',
    defaultValue: 1
  },
  stroked: {
    type: 'boolean',
    defaultValue: false
  },
  isTextVisible: {
    type: 'boolean',
    defaultValue: true
  },
  colorAggregation: {
    type: 'string',
    defaultValue: null
  },
  clusterLevel: {
    type: 'number',
    defaultValue: DEFAULT_AGGREGATION_LEVEL_CLUSTER - 1
  }
}

export default class ClusterTileLayer extends SpatialIndexLayer {
  constructor(props = {}) {
    super(props)
    this.registerVisConfig(DEFAULT_VIS_CONFIG)
  }

  public get type() {
    return LayerTypes.ClusterTile
  }

  get name() {
    return 'Cluster'
  }

  getDefaultLayerConfig(props = {}): any {
    const baseConfig = super.getDefaultLayerConfig(props)
    return {
      ...baseConfig,

      // Text
      textLabel: [
        {
          ...baseConfig.textLabel[0],
          color: [255, 255, 255],
          outlineColor: [44, 48, 50]
        }
      ]
    }
  }

  static findDefaultLayerProps(dataset: KeplerTable, foundLayers) {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }
    const scheme = getSchemeFromTilesetDataset(dataset)

    if (getDatasetType(dataset) === MapType.tileset && scheme === TilingScheme.Quadbin) {
      return {
        props: [
          {
            label: dataset.label,
            isVisible: true,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }
}
